import React from 'react';
import { Link, NavLink, Navigate, Outlet, useNavigate } from 'react-router-dom';
import { LayoutDashboardIcon, FolderIcon, ReceiptIcon, UserIcon, LogOutIcon } from 'lucide-react';
import { Logo } from '../../components/brand/Logo';
import { usePortalAuth } from '../../context/PortalAuth';
const NAV = [{
  to: '/portal/dashboard',
  label: 'Dashboard',
  icon: LayoutDashboardIcon
}, {
  to: '/portal/deliverables',
  label: 'Deliverables',
  icon: FolderIcon
}, {
  to: '/portal/invoices',
  label: 'Invoices',
  icon: ReceiptIcon
}, {
  to: '/portal/account',
  label: 'Account',
  icon: UserIcon
}];
export function PortalLayout() {
  const {
    user,
    signOut
  } = usePortalAuth();
  const navigate = useNavigate();
  if (!user) return <Navigate to="/portal/login" replace data-id="element-1019" data-mp="3m9cu0e6an81m" />;
  const onSignOut = () => {
    signOut();
    navigate('/portal/login');
  };
  return <div className="flex min-h-screen w-full flex-col bg-mist lg:flex-row" data-id="element-1020" data-mp="1mzmo74wea1v7">
      <aside className="surface-dark flex shrink-0 flex-col justify-between px-5 py-6 lg:w-72 lg:px-6 lg:py-8" data-id="element-1021" data-mp="1rx6dr0yjm12g">
        <div data-id="element-1022" data-mp="kt2gpsjzchv2">
          <Link to="/" aria-label="Cavalla Solution, home" data-id="element-1023" data-mp="ksssa9el2irh">
            <Logo variant="reversed" data-id="element-1024" data-mp="fzhibzeh5lvc" />
          </Link>
          <nav aria-label="Portal" className="mt-10 flex flex-wrap gap-1 lg:flex-col" data-id="element-1025" data-mp="b0wpil1jy4gx">
            {NAV.map(item => {
            const Icon = item.icon;
            return <NavLink key={item.to} to={item.to} className={({
              isActive
            }) => `flex items-center gap-3 rounded-sm px-3 py-2.5 text-[15px] transition-colors ${isActive ? 'bg-white/12 text-white' : 'text-white/65 hover:bg-white/8 hover:text-white'}`} data-id="element-1026" data-mp="13ptw3qweictu">
                  <Icon className="h-4 w-4" aria-hidden="true" data-id="element-1027" data-mp="3ehn0zffwl9q0" />
                  {item.label}
                </NavLink>;
          })}
          </nav>
        </div>

        <div className="mt-10 border-t border-white/12 pt-6" data-id="element-1028" data-mp="3aie5a51az1rt">
          <p className="text-[15px] text-white" data-id="element-1029" data-mp="3bys1l9sk6v1m">{user.name}</p>
          <p className="mt-0.5 text-small text-white/50" data-id="element-1030" data-mp="3gwa0068y9rvd">{user.organisationName}</p>
          <button type="button" onClick={onSignOut} className="mt-4 inline-flex items-center gap-2 text-[14px] text-white/65 transition-colors hover:text-gold" data-id="element-1031" data-mp="31zaxuxwvar8a">
            <LogOutIcon className="h-4 w-4" aria-hidden="true" data-id="element-1032" data-mp="2t79057e6np1p" />
            Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 px-5 py-8 sm:px-8 lg:px-12 lg:py-12" data-id="element-1033" data-mp="2xyqz5pwnbfk1">
        <div className="mx-auto w-full max-w-4xl" data-id="element-1034" data-mp="2j91maxf6xn3x">
          <Outlet data-id="element-1035" data-mp="2jacpav0taqtz" />
        </div>
      </main>
    </div>;
}